import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import { Provider } from 'react-redux';
import { createStore, applyMiddleware } from 'redux';
import reduxImmutableStateInvariant from 'redux-immutable-state-invariant';
import thunk from 'redux-thunk';
import rootReducer from './reducers/index';
import './index.css';
import { saveState } from './webappointment/functions/loadState';

const initialState = {};

const store = createStore(
  rootReducer,
  initialState,
  applyMiddleware(thunk, reduxImmutableStateInvariant())
);

store.subscribe(() => {
  saveState(store.getState());
});

ReactDOM.render(
  <span className="web-appointment">
    <Provider store={store}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </Provider>
  </span>,
  document.getElementById('root')
);
